//
// Input store
//
// Handles non-authenticated user input (pins).
//

import * as client from 'api/client';
import { createPin } from './pins';

// ------------------------------------
// Action definitions
// ------------------------------------

export const VALIDATE_CODE   = 'INPUT/VALIDATE_CODE';
export const CODE_VALID      = 'INPUT/CODE_VALID';
export const CODE_INVALID    = 'INPUT/CODE_INVALID';
export const SET_LOCATION    = 'INPUT/SET_LOCATION';
export const SUBMIT          = 'INPUT/SUBMIT';
export const RESET           = 'INPUT/RESET';

// ------------------------------------
// Action creators
// ------------------------------------

export const validateCode = code => dispatch => {
  dispatch({ type: VALIDATE_CODE });

  return client.post('/api/validate', { code })
    .then(() => dispatch({ type: CODE_VALID, code }))
    .catch(error => dispatch({ type: CODE_INVALID, error }));
};

export const setLocation = location => ({
  type: SET_LOCATION,
  location
});

export const submit = ({ creator, title, body, image, lat, lng }) => (dispatch, getState) => {
  const state = getState();

  // Clean input to make sure it validates.
  const data = new FormData();
  data.append('code', state.input.code);
  data.append('creator', creator.substring(0, 50));
  data.append('title', title.substring(0, 50));
  data.append('body', body.substring(0, 500));
  data.append('lat', lat);
  data.append('lng', lng);
  image && data.append('image', image);

  dispatch(createPin(data));
  dispatch(reset());
};

export const reset = () => ({
  type: RESET
});

// ------------------------------------
// Initial state
// ------------------------------------

const initialState = {
  validating: false,
  code: null,
  error: null,
  location: null
};

// ------------------------------------
// Reducer
// ------------------------------------

export default (state = initialState, action) => {
  switch (action.type) {
    case VALIDATE_CODE:
      return {
        ...initialState,
        validating: true
      };

    case CODE_VALID:
      return {
        ...state,
        validating: false,
        code: action.code
      };

    case CODE_INVALID:
      return {
        ...state,
        validating: false,
        error: action.error
      };

    case SET_LOCATION:
      return {
        ...state,
        location: action.location
      };

    case RESET:
      return initialState;

    default:
      return state
  }
};

// ------------------------------------
// Utils
// ------------------------------------

export const getCode = state => state.code.code;

export const getLocation = state => state.code.location;



// WEBPACK FOOTER //
// ./src/store/modules/input.js